import React, {useState, useEffect} from "react";
import {getEntityFromInput, getMockEntityFromInputResponseForGMDPkg} from "../../commons/api/GetEntityDetails.js";
import Loader from "@amzn/meridian/loader";
import Row from "@amzn/meridian/row";
import { PackageDetailView } from "./packageDetails/PackageDetailView.js";
import { ContainerDetailView } from "./containerDetails/ContainerDetailView.js";
import {SearchView} from "./SearchView.js";
import { AssociateDetailsView } from "./associateDetails/AssociateDetailsView.js";
import { WorkcellDetailsView } from "./workcellDetails/WorkcellDetailsView.js";
import { ErrorPageView } from "./ErrorPageView.js";
import {getDocumentURL} from "../../handler/ParentDataHandler";
import {FEATURES, GAMEDAY_PACKAGE_ID_PREFIX} from "../../commons/constants/CommonConstants";
import {getFeatureStatus} from "../../commons/CommonUtils";

export const DetailPage = (props) => {

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');

    var pathnames = props.location.pathname.split("/").filter(x => x);
    var entityId = props.match.params.entityId;
    var context = props.match.params.detailParam ? JSON.parse(props.match.params.detailParam) : {};
    var previousPathForBreadCrumb = props.match.params.detailParam ? `/${pathnames.slice(0, pathnames.length - 2).join('/')}`
        : `/${pathnames.slice(0, pathnames.length - 1).join('/')}`;

    const [entityDetails, setEntityDetails] = useState(undefined);
    const [baseURL, setBaseURL] = useState("");



    useEffect(() => {
        setEntityDetails(undefined);
        getDocumentURL().then(result => {
            setBaseURL(result);
        });
        entityId = props.match.params.entityId;
        context = props.match.params.detailParam ? JSON.parse(props.match.params.detailParam) : {};
        if (context && (context.type === 'ASSOCIATE' || context.type === 'WORKCELL')) {
            return;
        } else if (entityId) {
            fetchEntityDetails(entityId).then((entityData) => {
                setEntityDetails(entityData);
            });
        }
    }, [props.match.params.entityId, props.match.params.detailParam]);

    const fetchEntityDetails = async (entityId) => {
        try {
            const isGMDPackageVisibilityEnabled = await getFeatureStatus(FEATURES.IS_GAMEDAY_PACKAGE_HISTORY_VISIBILITY_ENABLED)
            if (isGMDPackageVisibilityEnabled && entityId.startsWith(GAMEDAY_PACKAGE_ID_PREFIX)) {
                console.warn("GMD package visibility enabled, returning mock response for EntityFromInput")
                return getMockEntityFromInputResponseForGMDPkg(entityId);
            }
            return await getEntityFromInput(entityId, stationCode)
        } catch (e) {
            return null;
        }
    }

    const todayDate =  new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000);
    const tomorrowDate = new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000) + (60 * 60 * 24 * 1000);

    let entityType = entityDetails === undefined ? undefined : entityDetails ? entityDetails.type : null;

    //Need to simplify this.
    if (context && context.type) {
        if (entityType === context.type) {
            return <div>
                {!entityId ? <SearchView baseURL={baseURL} nodeId = {stationCode}/> :
                entityType === "PACKAGE" ? <PackageDetailView previousPath = {previousPathForBreadCrumb} entityDetails = {entityDetails} nodeId = {stationCode} packageId = {entityId} startDate = {context.startDate ? context.startDate : todayDate} endDate = {context.endDate ? context.endDate : tomorrowDate} history = {props.history} /> :
                entityType === "CONTAINER" ? <ContainerDetailView previousPath = {previousPathForBreadCrumb} entityDetails = {entityDetails} nodeId = {stationCode} startDate = {context.startDate ? context.startDate : todayDate} endDate = {context.endDate ? context.endDate : tomorrowDate} history = {props.history}/> :
                entityType === "ASSOCIATE" ? <AssociateDetailsView previousPath = {previousPathForBreadCrumb} associateLoginId = {entityId} startDate = {context.startDate ? context.startDate : todayDate} endDate = {context.endDate ? context.endDate : tomorrowDate} history = {props.history}></AssociateDetailsView> :
                entityType === "WORKCELL" ? <WorkcellDetailsView previousPath = {previousPathForBreadCrumb} workcellId = {entityId} startDate = {context.startDate ? context.startDate : todayDate} endDate = {context.endDate ? context.endDate : tomorrowDate} history = {props.history}></WorkcellDetailsView> :
                entityType === null ? <ErrorPageView entityType = "Entity" entityId = {entityId} history = {props.history}/>
                : <Row alignmentHorizontal="center" spacingInset="xlarge none"><Loader/></Row>}
            </div>
        } else {
            if (context.type === "ASSOCIATE") {
                return <AssociateDetailsView previousPath = {previousPathForBreadCrumb} associateLoginId = {entityId} startDate = {context.startDate ? context.startDate : todayDate} endDate = {context.endDate ? context.endDate : tomorrowDate} history = {props.history}></AssociateDetailsView>;
            }
            if (context.type === "WORKCELL") {
                return <WorkcellDetailsView previousPath = {previousPathForBreadCrumb} workcellId = {entityId} startDate = {context.startDate ? context.startDate : todayDate} endDate = {context.endDate ? context.endDate : tomorrowDate} history = {props.history}></WorkcellDetailsView>;
            }
            return entityType === null ? <ErrorPageView entityType = {context.type.charAt(0) + context.type.slice(1).toLowerCase()} entityId = {entityId} history = {props.history}/>
            : <Row alignmentHorizontal="center" spacingInset="xlarge none"><Loader/></Row>;
        }

    } else {
        return <div>
            {!entityId ? <SearchView baseURL={baseURL} nodeId = {stationCode}/> :
            entityType === "PACKAGE" ? <PackageDetailView previousPath = {previousPathForBreadCrumb} entityDetails = {entityDetails} nodeId = {stationCode} packageId = {entityId} startDate = {context.startDate ? context.startDate : todayDate} endDate = {context.endDate ? context.endDate : tomorrowDate} history = {props.history} /> :
            entityType === "CONTAINER" ? <ContainerDetailView previousPath = {previousPathForBreadCrumb} entityDetails = {entityDetails} nodeId = {stationCode} startDate = {context.startDate ? context.startDate : todayDate} endDate = {context.endDate ? context.endDate : tomorrowDate} history = {props.history}/> :
            entityType === "ASSOCIATE" ? <AssociateDetailsView previousPath = {previousPathForBreadCrumb} associateLoginId = {entityId} startDate = {context.startDate ? context.startDate : todayDate} endDate = {context.endDate ? context.endDate : tomorrowDate} history = {props.history}></AssociateDetailsView> :
            entityType === "WORKCELL" ? <WorkcellDetailsView previousPath = {previousPathForBreadCrumb} workcellId = {entityId} startDate = {context.startDate ? context.startDate : todayDate} endDate = {context.endDate ? context.endDate : tomorrowDate} history = {props.history}></WorkcellDetailsView> :
            entityType === null ? <ErrorPageView entityType = "Entity" entityId = {entityId} history = {props.history}/>
            : <Row alignmentHorizontal="center" spacingInset="xlarge none"><Loader/></Row>}
        </div>
    }

}





// WEBPACK FOOTER //
// ./src/components/detailPages/DetailPage.js